<template>
  <div style="height: auto">
      <a-row v-for="(item,index) in dataList" :key="item.key" :item="initItemData(item)">
        <a-input
          type='text'
          v-model="item.name"
          style="width: 30%; margin-right: 2%;"
          placeholder="请输入卡种名称"
          @change="triggerChange"
        ></a-input>
        <a-input
          type='text'
          v-model="item.description"
          style="width: 30%; margin-right: 2%;"
          placeholder="请选择有效时间"
          readonly
          @change="triggerChange"
          @click="handleCarTimeClick(item,index)"
        ></a-input>
        <a-input-number
          :min="0"
          v-model="item.price"
          style="width: 18%;"
          :step="0.1"
          @change="triggerChange" />
        元
        <div style="margin-left: 2%;width: 55px;font-size: 14px;display: inline-block">
          <a-icon type="plus" style="background:#1890FF;color:#ffffff;border-radius: 50%;padding:5px;margin-right: 5px;"
          @click="handleAddRow(index)"/>
          <a-icon type="close" style="background:#1890FF;color:#ffffff;border-radius: 50%;padding:5px;"
          @click="handleRemoveRow(index)"/>
        </div>
      </a-row>
    <div>
      <card-time-modal ref="cardTimeForm"  :timeUnitOptions="timeUnitOptions" @ok="handleCardTimeModal"> </card-time-modal>
    </div>
  </div>
</template>

<script>
  import CardTimeModal from './CardTimeModal'
  import {initDictOptions,filterDictTextByCache} from '@/components/dict/JDictSelectUtil';
  const initItem = {
    name:"",
    key:Math.round(new Date().getTime()).toString(),//前端for循环key，不存数据库
    isPermanent:true,
    validityNumber:undefined,
    timeUnit:undefined,
    description:undefined,
    price:0.00,
  }
  export default {
    name: 'MemberLevelCard',
    components: {
      CardTimeModal
    },
    props: ['value'],
    data () {
      const value = this.value || [Object.assign({}, initItem)];
      return {
        timeUnitOptions:[],
        dataList:value||[Object.assign({}, initItem)],
        initItem:{
          name:"",
          isPermanent:true,
          validityNumber:undefined,
          timeUnit:undefined,
          description:undefined,
          price:0.00,
        },
        description:undefined,
        currentItem:undefined,
        currentIndex:undefined,
      }
    },
    created() {
      this.initDictConfig();
    },
    watch: {
      value(val = []) {
        this.dataList = val;
      },
    },
    methods: {
      _uuid(){
        let uuid = Math.round(new Date().getTime()).toString();
        return uuid;
      },
      initDictConfig() {
        console.log('--我才是真的方法!--');
        //初始化字典 - 客户类型
        initDictOptions('member_unit_validity').then(res => {
          if (res.success) {
            this.timeUnitOptions = res.result;
          }
        });
      },
      initItemData(item){
        let result = item;
        if(item.isPermanent == 1){
          result.description = "";
        }else{
          result.description = "购买后"+ item.validityNumber + filterDictTextByCache("member_unit_validity",item.timeUnit)+"有效"
        }
        // return result;
      },
      handleCardTimeModal(data){
        // let dataList = this.dataList;
        if(data.pmtFlg == 1){
          this.dataList[this.currentIndex].description = "永久有效";
          this.dataList[this.currentIndex].isPermanent = 1;
          this.dataList[this.currentIndex].validityNumber = "";
          this.dataList[this.currentIndex].timeUnit = "";
        }else{
          this.dataList[this.currentIndex].description = "购买后"+ data.validityNumber + filterDictTextByCache("member_unit_validity",data.timeUnit)+"有效"
          this.dataList[this.currentIndex].isPermanent = 0;
          this.dataList[this.currentIndex].validityNumber = data.validityNumber;
          this.dataList[this.currentIndex].timeUnit = data.timeUnit;
        }
        this.triggerChange();
        // console.log(data);
      },
      handleAddRow(index){
        this.$nextTick(() => {
          this.dataList.splice(index+1,0,Object.assign({}, initItem,{key:this._uuid()}));
          this.$forceUpdate()
        });


      },
      handleRemoveRow(index){
        if(this.dataList.length==1){
          this.$message.warning("至少需要一条记录");
          return;
        }
        this.dataList.splice(index,1)
      },
      handleCarTimeClick(item,index){
        this.currentItem = item;
        this.currentIndex = index;
        this.$refs.cardTimeForm.edit({
          pmtFlg:"0",
          // pmtFlg:item.isPermanent==1?"1":"0",
          validityNumber:item.validityNumber,
          timeUnit:item.timeUnit,
        });
      },
      triggerChange(e) {
        // Should provide an event to pass value to Form.
        let result = Object.assign([], this.dataList);
        delete result.description;
        this.$emit('change', result);
      },
    }
  }
</script>